import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import App from './App';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
        },
        '.MuiDialog-paper .MuiInputBase-input:not(.MuiInputBase-inputMultiline)': {
          paddingTop: 8.5,
          paddingBottom: 8.5,
        },
        '.MuiDialog-paper .MuiInputLabel-outlined': {
          transform: 'translate(14px, 9px) scale(1)',
        },
        '.MuiDialog-paper .MuiInputLabel-outlined.MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px) scale(0.75)',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          padding: 8,
          '& + &': {
            marginLeft: 4,
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          height: 40,
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          padding: theme.spacing(0, 3),
          lineHeight: 1.2,
        }),
      },
    },
    MuiTypography: {
      styleOverrides: {
        h4: {
          fontSize: '1.75rem',
          '@media (max-width:600px)': {
            fontSize: '1.35rem',
          },
        },
        h5: {
          fontSize: '1.3rem',
          '@media (max-width:600px)': {
            fontSize: '1.1rem',
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
